import request from '@/utils/request'

// getDrumList
export function getDrumList(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6100/getDrumList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// epms6110Save
export function epms6110Save(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6100/epms6110Save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
